import styled from 'styled-components';

const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

const Actions = styled.div`
  display: grid;
  grid-template-columns: 1fr 200px;
  grid-gap: 20px;

  button {
    margin-top: 40px;
  }

  ${props => props.theme.media.phone`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  
    .input-container {
      width: 100%;
    }

    button {
      margin: 0;
      width: 100%;
      margin-top: 20px;
    }
  `}
`;

export { Form, Actions };
